export default "__VITE_ASSET__BMPU5Lu8__"